import { loadStripe } from '@stripe/stripe-js';

/**
 * Stripe Client Configuration
 * Initializes the Stripe client for payment processing
 */

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Debug: Log environment variable status (only in development)
if (import.meta.env.DEV) {
  console.log('🔍 Stripe Environment Check:');
  console.log('  VITE_STRIPE_PUBLISHABLE_KEY:', stripePublishableKey ? '✅ Set' : '❌ Missing');
}

// Check if Stripe is configured
export const isStripeConfigured = !!stripePublishableKey;

if (!isStripeConfigured) {
  console.warn(
    '⚠️  Stripe publishable key is missing. Please set VITE_STRIPE_PUBLISHABLE_KEY in your .env file.\n' +
    'Payment functionality will be limited.\n' +
    '📝 Make sure:\n' +
    '   1. Your .env file is in the root directory\n' +
    '   2. Variable is prefixed with VITE_\n' +
    '   3. You have restarted the dev server after creating/updating .env\n' +
    '   4. No quotes around the value in .env'
  );
}

// Initialize Stripe instance
// This will be null if the key is not configured, but loadStripe handles this gracefully
let stripePromise = null;

if (isStripeConfigured) {
  stripePromise = loadStripe(stripePublishableKey);
} else {
  // Create a rejected promise to provide better error messages
  stripePromise = Promise.reject(new Error('Stripe publishable key not configured'));
}

/**
 * Get Stripe instance
 * Returns a promise that resolves to the Stripe instance
 * @returns {Promise<Stripe | null>}
 */
export const getStripe = () => {
  if (!isStripeConfigured) {
    return Promise.reject(new Error('Stripe is not configured. Please set VITE_STRIPE_PUBLISHABLE_KEY.'));
  }
  return stripePromise;
};

export default stripePromise;
